import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets scroll position on every client-side route change (browsers don't do this for SPAs).
 * If the destination carries a hash (e.g. NavBar's "/#ai" section links), scrolls that element
 * into view instead — React Router doesn't do native anchor-scroll on client-side navigation.
 */
export function ScrollToTop(): null {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      // Section content mounts async on route change — retry briefly instead of a fixed delay.
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
